// useSeo — Vue 3 composable: title, description, canonical, OG, Twitter, JSON-LD
// Kullanım: useSeo({ title, description, image, url, type, jsonLd })

const SITE_NAME = 'GelişimP Türkiye'
const SITE_URL = 'https://gelisimpturkiye.com'
const DEFAULT_IMAGE = SITE_URL + '/images/og-default.jpg'

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector)
  if (!el) {
    el = document.createElement('meta')
    Object.entries(attrs.create).forEach(([k, v]) => el.setAttribute(k, v))
    document.head.appendChild(el)
  }
  el.setAttribute('content', attrs.content)
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function upsertJsonLd(id, data) {
  let el = document.head.querySelector(`script[data-seo="${id}"]`)
  if (!el) {
    el = document.createElement('script')
    el.setAttribute('type', 'application/ld+json')
    el.setAttribute('data-seo', id)
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

export function useSeo(opts = {}) {
  const title = opts.title ? `${opts.title} | ${SITE_NAME}` : SITE_NAME
  const description = opts.description || ''
  const image = opts.image || DEFAULT_IMAGE
  const url = opts.url ? (opts.url.startsWith('http') ? opts.url : SITE_URL + opts.url) : SITE_URL + (typeof window !== 'undefined' ? window.location.pathname : '/')
  const type = opts.type || 'website'

  if (typeof document === 'undefined') return

  document.title = title

  upsertMeta('meta[name="title"]', { create: { name: 'title' }, content: title })
  if (description) {
    upsertMeta('meta[name="description"]', { create: { name: 'description' }, content: description })
  }
  upsertLink('canonical', url)

  // Open Graph
  upsertMeta('meta[property="og:type"]', { create: { property: 'og:type' }, content: type })
  upsertMeta('meta[property="og:url"]', { create: { property: 'og:url' }, content: url })
  upsertMeta('meta[property="og:title"]', { create: { property: 'og:title' }, content: title })
  if (description) {
    upsertMeta('meta[property="og:description"]', { create: { property: 'og:description' }, content: description })
  }
  upsertMeta('meta[property="og:image"]', { create: { property: 'og:image' }, content: image })

  // Twitter
  upsertMeta('meta[name="twitter:card"]', { create: { name: 'twitter:card' }, content: 'summary_large_image' })
  upsertMeta('meta[name="twitter:url"]', { create: { name: 'twitter:url' }, content: url })
  upsertMeta('meta[name="twitter:title"]', { create: { name: 'twitter:title' }, content: title })
  if (description) {
    upsertMeta('meta[name="twitter:description"]', { create: { name: 'twitter:description' }, content: description })
  }
  upsertMeta('meta[name="twitter:image"]', { create: { name: 'twitter:image' }, content: image })

  // JSON-LD (sayfa bazlı, var olanı override eder)
  if (opts.jsonLd) {
    upsertJsonLd('page', opts.jsonLd)
  }
}

export function createSlug(text) {
  return String(text || '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[ğ]/g, 'g')
    .replace(/[ü]/g, 'u')
    .replace(/[ş]/g, 's')
    .replace(/[ı]/g, 'i')
    .replace(/[ö]/g, 'o')
    .replace(/[ç]/g, 'c')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function stripHtml(s) {
  return String(s || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
}

export function truncate(s, n = 160) {
  const t = stripHtml(s)
  if (t.length <= n) return t
  return t.slice(0, n - 1).replace(/\s+\S*$/, '') + '…'
}

export { SITE_URL, SITE_NAME, DEFAULT_IMAGE }
